// English translations - Modular structure
// Using require for JSON to ensure compatibility
const common = require('./common.json');
const layout = require('./layout.json');
const auth = require('./auth.json');
const shop = require('./shop.json');
const blog = require('./blog.json');
const tools = require('./tools.json');
const marketing = require('./marketing.json');
const mycolab = require('./mycolab.json');
const apiDocs = require('./api_docs.json');
const gamification = require('./gamification.json');
const internalDocs = require('./internal_docs.json');
const home = require('./home.json');

const en = {
  ...common,
  ...layout,
  ...auth,
  ...shop,
  ...blog,
  ...tools,
  ...marketing,
  ...mycolab,
  ...apiDocs,
  ...gamification,
  ...internalDocs,
  ...home,
};

export default en;
